import type { SharedCustomField } from '@/types/serializers';
import type { CustomField } from '../types/Organization';

const toCustomFieldType = (
  fieldType: SharedCustomField['field_type']
): CustomField['field_type'] => {
  switch (fieldType) {
    case 'single_select':
      return 'select';
    case 'multiple_select':
      return 'multi_select';
    case 'datetime':
      return 'date';
    default:
      return fieldType;
  }
};

export const mapSharedToCustomFields = (
  fields: SharedCustomField[] | null | undefined
): CustomField[] => {
  if (!fields) return [];

  return fields.map((field) => ({
    id: field.id,
    name: field.name,
    field_type: toCustomFieldType(field.field_type),
    unit_name: field.unit_name,
    order_number: field.order_number,
    is_required: field.is_required,
    alias_id: field.alias_id ?? '',
    custom_field_options: field.custom_field_options.map((option) => ({
      id: option.id,
      name: option.value,
      value: option.value,
    })),
    custom_category: {
      id: field.custom_category.id,
      name: field.custom_category.name,
    },
  }));
};
